/** @hidden */
export const IDENTITY_STORAGE_KEY = 'ArcId.USER_INFO';

/** @hidden */
export const PROFILE_STORAGE_KEY = 'ArcId.USER_PROFILE';

/** @hidden */
export const PROFILE_STORAGE_KEY_EXPIRED_TIME = 'ArcId.USER_PROFILE_EXPIRED_TIME';

/** @hidden */
export const USER_SETTINGS_STORAGE_KEY = 'ArcId.USER_SETTINGS';

/** @hidden */
export const AMP_ID_STORAGE_KEY = 'ArcId.AMP_READER_ID';

/** @hidden */
export const headers = { 'Content-Type': 'application/json' };

/**@hidden */
export const logPrefix = '[Arc Identity SDK]';

/** @hidden */
export const USER_SEGMENTS_STORAGE_KEY = 'ArcId.USER_SEGMENTS';
